import React from 'react';
import './ErrorDialog.css'; // Estilos personalizados

import PropTypes from 'prop-types';

const ErrorDialog = ({ message, onClose }) => {
  return (
    <div className="error-dialog-overlay">
      <div className="error-dialog-box">
        <p>{message}</p>
        {onClose && <button onClick={onClose}>Cerrar</button>}
      </div>
    </div>
  );
};

ErrorDialog.propTypes = {
  message: PropTypes.string.isRequired,
  onClose: PropTypes.func,
};

export default ErrorDialog;
